import React from 'react';
import {getDate, useStyles} from './helper';

const PaymentItem = ({item, array}) => {
    const classes = useStyles();

    const Component = ({event_date, tag, sum, login_user, groups, air, amount, amount2}) => (
        <div className={classes.root}>
                <span className={classes.date}>{getDate(event_date)}</span>
                <span className={classes.tag}>{tag}</span>
                <span>{login_user}({groups})</span>
                { 
                    air &&
                    <>
                        <span>Вывод: {amount}</span>
                        <span>Отжато: {amount2}</span>
                    </>
                }    
                <span className={classes.sum}>К выводу: {sum}</span>
            </div>
    )

    if (array) {
        const {login_user, groups, summ, event_date, air_type, air} = item[0];
        const {summ: summ2, air_type: air_types} = item[1];
        const amount = !air ? summ + summ2 - summ2 : summ + summ2 - summ;
        return (
            <Component 
                event_date={event_date} 
                tag={air_type === 'lifting' || air_types === 'lifting' ? 'Статус' : 'Акция'}
                sum={`${new Intl.NumberFormat('ru-RU').format(amount ? (Math.abs(amount)).toFixed(2) : 0)}`} 
                login_user={login_user}
                groups={groups}
                air
                amount={summ2 + summ}
                amount2={air ? summ : summ2}
            />
        )
    }
    const {summ} = item;
    if (summ) {
        const {login_user, groups, event_date} = item;
        return (
            <Component 
                event_date={event_date} 
                tag="Вывод"
                sum={new Intl.NumberFormat('ru-RU').format(summ ? summ.toFixed(2) : summ)}
                login_user={login_user}
                groups={groups}
            />
        )
    }
    return <></>

}

export default PaymentItem;